<template>
  <div>
    <div class="totalPie">
      <!-- 耿彪修改 -->
      <div class="tit">
        <p>工情信息预警</p>
      </div>
      <ul class="listwarning listb">
        <li>
          <div>
            <p class="titnames1">地市名</p>
          </div>
          <div>
            <p class="titnames1">淤地坝名称</p>
          </div>
          <div>
            <p class="titnames1">坝体位移监测</p>
          </div>
          <div>
            <p class="titnames1">泄水部位变形监测</p>
          </div>
         <!-- <div>
            <p class="titnames1">溃坝指数</p>
          </div> -->
        </li>
      </ul>
      <ul class="listwarning">
        <li v-for="(item,i) in warninglist" :key="i">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.ydbName}}</p>
          </div>
          <div>
            <p class="titnames" v-if="item.lswyjWxzs!=null" :style="item.lswyjWxzs == 0 ? 'color:lime' : 'color:#ff6464'">{{item.lswyjWxzs == 0 ? "正常" : "报警"}}</p>
            <p class="titnames" v-if="item.lswyjWxzs==null" :style="item.lswyjWxzs == null ? 'color:lime' : 'color:#ff6464'">正常</p>
          </div>
          <div>
            <p class="titnames1" v-if="item.ztcgqWxzs!=null" :style="item.ztcgqWxzs == 1 ? 'color:lime' : 'color:#ff6464'">{{item.ztcgqWxzs == 1 ? "正常" : "报警"}}</p>
            <p class="titnames1" v-if="item.ztcgqWxzs==null" :style="item.ztcgqWxzs == null ? 'color:lime' : 'color:#ff6464'">正常</p>
          </div>
         <!-- <div>
            <p class="titnames1" v-if="item.fangxunYj!=null" :style="item.fangxunYj > 30 ? 'color:#ff6464' : 'color:lime'">{{item.fangxunYj}}%</p>
            <p class="titnames1" v-if="item.fangxunYj==null" :style="item.fangxunYj > 30 ? 'color:#ff6464' : 'color:lime'">0</p>
          </div> -->
        </li>
      </ul>
    </div>
    <!-- <div class="totalPie">
      <div class="tit">
        <p>应急预案落实情况</p>
        <cityselect v-on:citySelected="citySelected" style="padding-top: 8px;"></cityselect>
      </div>
      <ul class="yjlist listb">
        <li>
          <div>
            <p class="titnames">地市名称</p>
          </div>
          <div>
            <p class="titnames">淤地坝数量</p>
          </div>
          <div>
            <p class="titnames1">落实率</p>
          </div>
        </li>
      </ul>
      <ul class="yjlist">
        <li v-for="(item,i) in practicablelist" :key="i" :class="practicablelist.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.probability < 60 ? 'color:#ff6464' : 'color:lime'">{{0}}%</p>
          </div>
        </li>
      </ul>
    </div> -->
    <!-- <div class="zrrlist">
      <div class="tit">
        <p>各级责任人清单</p>
        <cityselect v-on:citySelected="citySelected2" style="padding-top: 8px;"></cityselect>
      </div>
      <ul>
        <li v-for="(item,i) in qdlist" :key="i">
          <img src="../../common/images/fxxzfzr.png" class="qdimg" v-if="item.code==1&&regionactivelen==0" />
          <img src="../../common/images/fxjsfzr.png" class="qdimg" v-if="item.code==2&&regionactivelen==0" />
          <img src="../../common/images/fxxc.png" class="qdimg" v-if="item.code==3&&regionactivelen==0" />
          <img src="../../common/images/skbm.png" class="qdimg" v-if="item.code==4&&regionactivelen==0" />
          <img src="../../common/images/skgl.png" class="qdimg" v-if="item.code==5&&regionactivelen==0" />

          <p class="shix" v-if="regionactivelen!=0">{{item.city}}</p>
          <div class="qdtext" :class="regionactivelen!=0?'qdtextxs':''">
            <p>{{item.textl}}</p>
            <p>
              <span>{{item.name}}</span>
              <span></span>
              <span>{{item.tel}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
  import {
    yjyalsqk,
    ydbOwner,
    yjqd
  } from "@/api/api.js";
  import cityselect from "../../components/cityselect/cityselect.vue";
  export default {
    // props: ["Nlssx"],
    components: {
      cityselect: cityselect,
    },
    data() {
      return {
        warninglist: [],
        practicablelist: [],
        qdlist: [],
        regionactivelen: 0,
      };
    },
    methods: {
      citySelected(val) {
        let params = {
          type: val.id
        };
        this.yjyalsqkFun(params);
      },
      citySelected2(val) {
        this.regionactivelen = val.id;
        let params = {
          type: val.id
        };
        this.zrrlists(params);
      },
      yjyalsqkFun(params) {
        yjyalsqk(params).then((res) => {
          this.practicablelist = res.data;
        });
      },
      //责任人清单省市县三级
      zrrlists(params) {
        this.qdlist = [];
        ydbOwner(params).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            this.qdlist.push({
              code: 1,
              textl: "防汛行政责任人",
              city: res.data[i].city,
              name: res.data[i].name,
              tel: res.data[i].phone,
            });
          }
        });
      },
    },
    mounted() {
      // let params = {
      //   type: 0
      // };
      // this.yjyalsqkFun(params);
      // this.zrrlists(params);
      let params = {};
      yjqd(params).then((res) => {
        this.warninglist = res.data;
      });
    },
    watch: {},
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 250px;
    /* height: auto; */
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    margin-top: 15px;
    padding-bottom: 15px;
  }

  .zrrlist {
    /* overflow: auto; */
    margin-top: 15px;
  }

  .zrrlist ul {
    width: 90%;
    margin: 0 auto;
  }

  .zrrlist ul li {
    width: 100%;
    height: 45px;
    border-bottom: 1px solid #098dc7;
    cursor: pointer;
  }

  .tit {
    padding-bottom: 10px;
    border-bottom: 1px solid #098dc7;
  }

  .tit p {
    margin-top: 15px;
    /* font-size: 14px; */
  }

  .tit ul {
    margin-top: 10px;
  }

  .yjlist {
    width: 90%;
    margin: 0 auto;
    /* margin-top: 10px; */
    height: calc(100% - 75px);
    height: -webkit-calc(100% - 75px);
    height: -moz-calc(100% - 75px);
    overflow: auto;
  }

  .yjlist li {
    width: 100%;
    height: 35px;
    border-top: 1px solid #098dc7;
    cursor: pointer;
  }

  .yjlist li div:nth-child(1) {
    width: 30%;
    float: left;
    height: 35px;
  }

  .yjlist li div:nth-child(2) {
    width: 40%;
    float: left;
  }

  .yjlist li div:nth-child(3) {
    width: 30%;
    float: left;
  }

  .yjlist li:nth-child(even) {
    background: rgba(0, 179, 254, 0.1);
  }

  .listwarning {
    width: 90%;
    margin: 0 auto;
    height: calc(100% - 90px);
    height: -webkit-calc(100% - 90px);
    height: -moz-calc(100% - 90px);
    overflow: auto;
  }

  .listwarning li {
    width: 100%;
    height: 35px;
    border-top: 1px solid #098dc7;
    cursor: pointer;
  }

  .ddd {
    border-bottom: 1px solid #098dc7;
  }

  .listwarning li div:nth-child(1) {
    width: 14%;
    float: left;
    height: 35px;
  }

  .listwarning li div:nth-child(2) {
    width: 29%;
    float: left;
    height: 35px;
  }

  .listwarning li div:nth-child(3) {
    width: 25%;
    float: left;
    height: 35px;
  }

  .listwarning li div:nth-child(4) {
    width: 30%;
    float: left;
    height: 35px;
  }

  .listwarning li div {
    width: 14%;
    float: left;
    height: 35px;
  }

  .titnames {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-right: 1px solid #098dc7;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .titnames1 {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sta1 {
    height: 35px;
    overflow: hidden;
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    line-height: 35px;
    color: #fff;
    font-size: 14px;
    padding-right: 15px;
  }

  .listb {
    border-bottom: none;
    height: 36px;
    margin-top: 10px;
  }

  .listb li {
    background: rgba(0, 179, 254, 0.5);
    height: 35px;
  }

  .listb li div p {
    line-height: 30px !important;
    margin-top: 0px;
  }

  .list li:nth-child(even) {
    background: rgba(0, 179, 254, 0.1);
  }

  .qdimg {
    width: 20px;
    height: 20px;
    float: left;
    margin-top: 11px;
    margin-left: 10px;
  }

  .shix {
    float: left;
    width: 60px;
    text-align: center;
    color: #fff;
    border: 1px solid #098dc7;
    margin-top: 10px;
    line-height: 20px;
    border-radius: 4px;
  }

  .yjimg {
    width: 24px;
    height: 24px;
    margin-top: 6px;
    margin-left: 40%;
  }

  .qdtext {
    width: calc(100% - 44px);
    width: -webkit-calc(100% - 44px);
    width: -moz-calc(100% - 44px);
    float: right;
    height: 45px;
    margin-left: 10px;
  }

  .qdtextxs {
    width: calc(100% - 80px);
    width: -webkit-calc(100% - 80px);
    width: -moz-calc(100% - 80px);
  }

  .qdtext p:nth-child(1) {
    color: #00b3fe;
    font-size: 14px;
    width: 1005;
    line-height: 12px;
    margin-top: 7px;
  }

  .qdtext p:nth-child(2) {
    color: #fdfdfd;
    font-size: 14px;
    width: 1005;
    line-height: 12px;
    margin-top: 5px;
  }

  .qdtext p:nth-child(2) span:nth-child(1) {
    margin-right: 8px;
    border-right: 1px solid #fdfdfd;
    padding-right: 8px;
    font-size: 14px;
    display: block;
    float: left;
    height: 12px;
  }

  .qdtext p:nth-child(2) span:nth-child(2) {
    display: block;
    width: 12px;
    height: 12px;
    background: url(../../common/images/tel.png) no-repeat center;
    background-size: 100% 100%;
    float: left;
    margin-right: 6px;
  }
</style>
z
